import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Accordion } from 'client/widget-components';
import { Span } from 'client/widget-components/basicComponents';
import { nestResponsiveStyles } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React from 'react';
import { menuSelectors, textSelectors } from './utils';
import { useFilterSortContext } from './utils/filterSortContext';

export interface MenuItemProps {
    title: string;
    children: React.ReactNode;
    id: string;
    dataAuto?: string;
}

export default function MenuItem({
    title,
    children,
    dataAuto,
    id,
}: MenuItemProps) {
    const { styles, openedMenuItemId, toggleMenuItem } = useFilterSortContext();
    const { menuStyle, textStyle } = styles;

    return (
        <>
            <Accordion
                title={title}
                styles={{
                    title: textStyle?.title,
                    headerWrapper: textStyle?.title,
                }}
                isAccordionOpen={openedMenuItemId === id}
                onToggleOpen={() => toggleMenuItem(id)}
                data-auto={dataAuto}
                dataGrabs={{ titleDataGrab: textSelectors.title }}
            >
                {children}
            </Accordion>
            <Span
                styles={[
                    dividerDefaultStyles,
                    menuStyle?.divider,
                    nestResponsiveStyles(
                        {
                            [RuntimeMediaQuery.COMMON]: {
                                display: 'none',
                            },
                        },
                        { innerSelector: '&:last-child' }
                    ),
                ]}
                data-grab={menuSelectors.divider}
            />
        </>
    );
}

const dividerDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        width: '100%',
        backgroundColor: '#e1e1e1',
        marginBlock: '24px',
        display: 'block',
        height: '2px',
        minHeight: '2px',
    },
};
